import * as types from '../../actions/actiontypes';

import Utility from '../../util/utilityfunctions';
import initialState from '../initialstate';

export function clientRequestCustomFiltersReducer(state = initialState.clientRequestsCustomFilter, action) {
	switch (action.type) {
		case types.SET_CLIENT_REQUESTS_FILTERS_BULK: {
			let requestsFilters = action.state ? JSON.parse(action.state) : state;
			return {
				...state,
				...requestsFilters
			};
		}

		case types.SET_CLIENT_REQUESTS_FILTER: {
			let value = action.value;
			if (!Utility.hasValue(value)) {
				//If filter is being disabled, set to empty array so it's removed from the URL.
				value = [];
			}

			if (action.filterItemName) {
				if (value.length < 1) {
					const {[action.filterItemName]: removedProperty, ...stateRest} = state;
					return stateRest;
				}
				let filters;
				filters = {...state};
				filters[action.filterItemName] = value;
				return {
					...state,
					...filters
				};
			}
			return state;
		}

		case types.CLEAR_CLIENT_REQUESTS_FILTERS: {
			return {};
		}

		default:
			return state;
	}
}
